import './index.css';

// PrimeReact styles
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primeicons/primeicons.css';

import { CourseBuilder, CourseSettings, UserSettings, UserProfile, SettingsManager } from './components';
import React from "react"
import ReactDOM from "react-dom"
import domReady from '@wordpress/dom-ready';
import { createRoot } from '@wordpress/element';
import { Provider } from 'react-redux';
import store from './store';

domReady( () => {
  const courseBuilderRoot = document.querySelector("#course-builder-root");
  if(courseBuilderRoot) {
    const params = new URLSearchParams(window.location.search);
    const courseID = params.get('post');
    const userID = params.get('user_id');
    const courseRoot = createRoot(courseBuilderRoot);
    courseRoot.render(
      <Provider store={store}>
        <SettingsManager userID={userID} courseID={courseID}/>
      </Provider>
    );
  }

  const studentBuilderRoot = document.querySelector("#student-builder-root");
  if (studentBuilderRoot) {
    const studentRoot = createRoot(studentBuilderRoot);
    studentRoot.render(
      <Provider store={store}>
        <SettingsManager />
      </Provider>
    );
  }

  const settingsManagerRoot = document.querySelector("#settings-manager-root");

  if (settingsManagerRoot) {
    const userID = settingsManagerRoot.getAttribute('data-user-id');
    const courseID = settingsManagerRoot.getAttribute('data-course-id');
    console.log('test')
    const root = createRoot(settingsManagerRoot);
    root.render(
      <Provider store={store}>
        <SettingsManager userID={userID} courseID={courseID} />
      </Provider>
    );
  }

} );
